import { useEffect } from 'react';

/**
 * Syncs the `lang` attribute on `<html>` with the current route's language
 * parameter. This allows CSS `[lang="xx"]` selectors in fonts.css to apply
 * the correct font family and weights for the active language.
 *
 * Restores the original value on unmount so pages outside the
 * `/:lang/:city` routes are unaffected.
 */
export function useSyncHtmlLang(lang: string): void {
  useEffect(() => {
    const prev = document.documentElement.lang;
    document.documentElement.lang = lang;
    return () => {
      document.documentElement.lang = prev;
    };
  }, [lang]);
}
